import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/*
 * @Description: 缓存清理
 * @Author: rhd
 * @Date: 2025-09-30 18:13:20
 * @LastEditors: rhd
 * @LastEditTime: 2025-09-30 18:15:02
 */
// src/utils/cacheCleaner.js
export var CacheCleaner = /*#__PURE__*/function () {
  function CacheCleaner() {
    _classCallCheck(this, CacheCleaner);
  }
  return _createClass(CacheCleaner, null, [{
    key: "clearLocalStorage",
    value:
    // 清除所有 localStorage
    function clearLocalStorage() {
      try {
        localStorage.clear();
        console.log('LocalStorage cleared successfully');
      } catch (error) {
        console.error('Error clearing localStorage:', error);
      }
    }

    // 清除所有 sessionStorage
  }, {
    key: "clearSessionStorage",
    value: function clearSessionStorage() {
      try {
        sessionStorage.clear();
        console.log('SessionStorage cleared successfully');
      } catch (error) {
        console.error('Error clearing sessionStorage:', error);
      }
    }

    // 清除 IndexedDB
  }, {
    key: "clearIndexedDB",
    value: function () {
      var _clearIndexedDB = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var databases;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return window.indexedDB.databases();
            case 3:
              databases = _context.sent;
              databases.forEach(function (db) {
                if (db.name) {
                  window.indexedDB.deleteDatabase(db.name);
                }
              });
              console.log('IndexedDB cleared successfully');
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error('Error clearing IndexedDB:', _context.t0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      function clearIndexedDB() {
        return _clearIndexedDB.apply(this, arguments);
      }
      return clearIndexedDB;
    }() // 清除 Service Worker 缓存
  }, {
    key: "clearServiceWorkerCache",
    value: function () {
      var _clearServiceWorkerCache = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var cacheNames;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!('caches' in window)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 4;
              return caches.keys();
            case 4:
              cacheNames = _context2.sent;
              _context2.next = 7;
              return Promise.all(cacheNames.map(function (cacheName) {
                return caches.delete(cacheName);
              }));
            case 7:
              console.log('Service Worker cache cleared successfully');
            case 8:
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error('Error clearing Service Worker cache:', _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }));
      function clearServiceWorkerCache() {
        return _clearServiceWorkerCache.apply(this, arguments);
      }
      return clearServiceWorkerCache;
    }() // 清除所有缓存
  }, {
    key: "clearAllCache",
    value: function () {
      var _clearAllCache = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.clearServiceWorkerCache();
            case 2:
              _context3.next = 4;
              return this.clearIndexedDB();
            case 4:
              this.clearLocalStorage();
              this.clearSessionStorage();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function clearAllCache() {
        return _clearAllCache.apply(this, arguments);
      }
      return clearAllCache;
    }() // 自动清理旧版本缓存
  }, {
    key: "autoCleanOnUpdate",
    value: function autoCleanOnUpdate() {
      var currentVersion = process.env.VUE_APP_VERSION || '1.0.0';
      var storedVersion = localStorage.getItem('app_version');
      if (storedVersion !== currentVersion) {
        this.clearAllCache();
        localStorage.setItem('app_version', currentVersion);
      }
    }
  }]);
}();